import { CSSProperties } from 'react';

export const detailsItemStyles = {
  display: 'flex',
  gap: '1rem',
  p: '1rem',
};

export const fieldContainerWithCheckmarkStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  width: '100%',
};

export const dataClassificationTooltipStyles: CSSProperties = {
  paddingLeft: '3rem',
  margin: '0.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
};
